import { useQuery, type UseQueryResult } from "@tanstack/react-query";

import { useDomainServices } from "@/providers/DomainServices";

import { sessionQueryKeys } from "./sessionQueryKeys";

/**
 * Fetches the IDs of every device attached to a Session: devices attached
 * directly, plus those the backend infers from the `device_id` on the
 * Session's files or their datasets.
 */
export function useSessionDevices(
  sessionId: string,
): UseQueryResult<string[], Error> {
  const { sessionService } = useDomainServices();
  return useQuery<string[], Error>({
    queryKey: sessionQueryKeys.devices(sessionId),
    queryFn: ({ signal }) =>
      sessionService.listAllSessionDevices(sessionId, { abortSignal: signal }),
  });
}
